import { render, staticRenderFns } from "./DadosDasDespesas.vue?vue&type=template&id=3a60ebce&scoped=true&"
import script from "./DadosDasDespesas.vue?vue&type=script&lang=js&"
export * from "./DadosDasDespesas.vue?vue&type=script&lang=js&"
import style0 from "./DadosDasDespesas.vue?vue&type=style&index=0&id=3a60ebce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a60ebce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDivider,VFlex,VForm,VLayout,VSelect,VTextField})
